
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spiritual-wisdom",
      function () {
        return require("private-next-pages/spiritual-wisdom/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spiritual-wisdom"])
      });
    }
  